/* eslint-disable @typescript-eslint/no-explicit-any */
export const getPlatform = (): "web" | "mobile" | undefined => {
  if (typeof document !== "undefined") {
    return "web";
  } else if (typeof navigator !== "undefined" && navigator.product === "ReactNative") {
    return "mobile";
  }
};

export const isWeb = (): boolean => {
  return getPlatform() === "web";
};

export const isMobile = (): boolean => {
  return getPlatform() === "mobile";
};

export const isMobileDevice = (): boolean => {
  const userAgent: string = navigator.userAgent || navigator.vendor || (window as any).opera || "";
  return /iPhone|iPad|iPod|Android/i.test(userAgent);
};

export const isAppleDevice = (): boolean => {
  if (typeof navigator === "undefined" || typeof window === "undefined") {
    return false;
  }

  const userAgent: string = navigator.userAgent || navigator.vendor || (window as any).opera || "";
  const isIOSDevice = /iPad|iPhone|iPod/.test(userAgent);
  const isIPadOS = navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1;
  const isMac = navigator.platform === "MacIntel" && navigator.maxTouchPoints === 0;

  return isIOSDevice || isIPadOS || isMac;
};
